import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";

export default function CreateCategoryDialog({ open, onClose, setName, name, onCreate }) {
	return (
		<Dialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
			<DialogTitle id="alert-dialog-title">Create Category</DialogTitle>
			<DialogContent>
				<Grid container>
					<Grid item xs={12} sx={{ m: 0, p: 1 }}>
						<TextField
							id="name"
							label="Category Name"
							fullWidth
							value={name}
							variant="standard"
							onChange={(e) => setName(e.target.value)}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button onClick={onCreate} autoFocus disabled={name.length < 3}>
					Create
				</Button>
			</DialogActions>
		</Dialog>
	);
}
